import TheFooter from './TheFooter';

export default TheFooter;
